// list controller
RoleListController.$inject =    ['$scope','roleService'];
function RoleListController     ($scope, roleService){
    $scope.roles = [];
    let promises = [];

    promises.push(roleService.find({}))

    Promise.all(promises)
    .then(result => {
        $scope.roles = result[0];
    })
}

// Edit controller
RoleEditController.$inject =    ['$scope', '$routeParams','roleService', 'companyService'];
function RoleEditController     ($scope, $routeParams, roleService, companyService){
    $scope.role = {};
    $scope.companies = [];

    let role_id = $routeParams.id;
    let promises = [];

    promises.push(roleService.get(role_id));
    promises.push(companyService.find({}));

    Promise.all(promises)
    .then(result => {
        $scope.role = result[0];
        $scope.companies = result[1];
    })

    $scope.remove = roleService.remove
    $scope.update = roleService.update
}

// New controller
RoleNewController.$inject =    ['$scope','roleService','companyService'];
function RoleNewController     ($scope, roleService, companyService){
    $scope.role = {};
    $scope.companies = [];
    let promises = [];

    promises.push(companyService.find({}));

    Promise.all(promises)
    .then(result => {
        $scope.companies = result[0];
    })

    $scope.add = roleService.add;
}

app.controller('RoleEditController', RoleEditController)
app.controller('RoleNewController', RoleNewController)
app.controller('RoleListController', RoleListController)
